import { render, staticRenderFns } from "./default_call.vue?vue&type=template&id=39d918f2&scoped=true"
import script from "./default_call.vue?vue&type=script&lang=ts"
export * from "./default_call.vue?vue&type=script&lang=ts"
import style0 from "./default_call.vue?vue&type=style&index=0&id=39d918f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d918f2",
  null
  
)

export default component.exports